export function query(n) {
  const m = window.location.search.match(new RegExp('(\\?|&)' + n + '=([^&]*)(&|$)'));
  return !m ? '' : decodeURIComponent(m[2]);
}

/**
 *@description 读取location.hash值
 *
 *@param {String} n 名称
 *@return {String} hash值
 */
export function getHash(n) {
  const m = window.location.hash.match(new RegExp('(#|&)' + n + '=([^&]*)(&|$)'));
  return !m ? '' : decodeURIComponent(m[2]);
}

export function parseHref(url) {
  var adom = document.createElement('a');
  adom.href = url;
  return {
    domain: adom.hostname,
    pathname: adom.pathname,
    search: adom.search,
    hash: adom.hash
  };
}